<template>
    <div>
		<div class="card ml-1 mr-1 generic-card" style="margin-bottom:25px">
			<div class="card-title" style="padding: 10px 15px;border-bottom: 1px solid #eee;">
				<div class="row">
					<div class="col-xs-6 text-left">
						<slot name="move"></slot>
					</div>
					<div class="col-xs-6 text-right">
						<a href="javascript:void(0);" @click="onGenericChange(generic)">
							<span class="glyphicon glyphicon-remove"></span>
						</a>
					</div>
				</div>
			</div>
			<div class="card-img" :class="{ disable: !generic.enable }">
				<uploadfile v-model="generic.image_url" :height="156" data-vv-as="Generic Image" :data-vv-name="'generic_manage_' + vkey + '_image'" v-validate="isValidate ? 'required' : ''"></uploadfile>
				
			</div>
			<div :class="{'has-error': errors.has('generic_manage_' + vkey + '_image')}" style="padding: 0 10px">
				<span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_image')">
					{{ errors.first('generic_manage_' + vkey + '_image') }}
				</span>
			</div>
			
			<div class="card-body" :class="{ disable: !generic.enable }">
				<p class="card-title" :class="{'has-error': errors.has('generic_manage_' + vkey + '_title')}">
					<textarea name="title" id="title" style="width: 100%;resize: none;height: 50px;font-weight: 600" data-vv-as="Generic Title" :data-vv-name="'generic_manage_' + vkey + '_title'" class="form-control" v-model="generic.title" placeholder="Type here" @change="$emit('input',generic)" v-validate="isValidate ? 'required' : ''"></textarea>
					<span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_title')">
						{{ errors.first('generic_manage_' + vkey + '_title') }}
					</span>
				</p>

				<p class="card-text" :class="{'has-error': errors.has('generic_manage_' + vkey + '_subtitle')}">
					<textarea name="subtitle" id="subtitle" style="width: 100%;resize: none;height: 100px;" data-vv-as="Generic Subtitle" :data-vv-name="'generic_manage_' + vkey + '_subtitle'" class="form-control" v-model="generic.subtitle" placeholder="Type here" @change="$emit('input',generic)" v-validate="isValidate ? 'required' : ''"></textarea>
					<span class="text-error" v-show="errors.has('generic_manage_' + vkey + '_subtitle')">
						{{ errors.first('generic_manage_' + vkey + '_subtitle') }}
					</span>
				</p>
			</div>
			<ul class="list-group list-group-flush"  style="margin-bottom: 0px;" :class="{ disable: !generic.enable }">
			    <template v-if="generic.buttons.length > 0">
					<li class="list-group-item" style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center" v-for="(button,bindex) in generic.buttons" :key="bindex">
						<span>
							{{ button.title }} 
							<add-generic-button v-model="generic.buttons[bindex]" @onSave="editButton(bindex, $event)">
								<span class="glyphicon glyphicon-pencil"></span>
							</add-generic-button> 
							<a href="javascript:void(0);" @click="deleteButton(bindex)" style="margin-left: 10px;">
								<span class="glyphicon glyphicon-remove"></span>
							</a>
						</span> 
					</li>
				</template>
				<li v-if="generic.buttons.length < 3" class="list-group-item" style="border-left:none;border-right:none;border-bottom:none; border-top:1px solid #eee;border-radius: 0px;text-align: center" >
					<add-generic-button v-model="newButton" @onSave="addNewButton">
						<span class="glyphicon glyphicon-plus"></span> Add button
					</add-generic-button>
				</li>
			</ul>
		</div>
		
	</div>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'

import AddGenericButton from '@/components/view/chatbot/AddGenericButton'

export default{
	inject: ['$validator'],
	components: {
		specialtext,
		uploadfile,
		AddGenericButton
	},
	props: {
		value: {
			default: {}
		},
		isValidate: {
			default: false,
			type: Boolean
		},
		vkey: {
			default: 0,
			type: [String,Number]
		}
	},
	data: function() {
		return {
			generic : this.value,
			showModal : false,
			newButton: {
				title: '',
				type: 'web_url',
				url: '',
			}
		}
	},
	methods: {
		onSave: function(){
			this.$emit('onSave',this.generic)
		},
		onGenericChange: function(generic){
			// generic.enable = !generic.enable
			this.$emit('onDelete')
		},
		addNewButton: function(payload){
			if (this.generic.buttons.length < 3) {
				
				if (payload.type == 'web_url') {
					delete payload.payload
				} else if(payload.type == 'postback' || payload.type == 'phone_number'){
					delete payload.url
				} 
				this.generic.buttons.push(payload)
				this.newButton = {
					title: '',
					type: 'web_url',
					url: ''
				}
			}

		},
		editButton: function(index, payload){
			if (this.generic.buttons[index]) {
				// this.generic.buttons[index] = payload
				if (payload.type == 'web_url') {
					delete payload.payload
				} else if(payload.type == 'postback' || payload.type == 'phone_number'){
					delete payload.url
				}
				this.$set(this.generic.buttons, index , payload)
			}
		},
		deleteButton: function(index){
			this.generic.buttons.splice(index,1)
		}
	},
	watch: {
		value: function(){
			this.generic = this.value
		},
		'generic' : function(newVal, oldVal){
			// this.$emit('onSave')
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/elements/GenericManage.vue